import {Pipe, PipeTransform} from '@angular/core';
import {ResourceSystemTypes} from 'src/app/shared/constants/resource-types';

@Pipe({name: 'displaySystem', standalone: true})
export class DisplaySystemPipe implements PipeTransform {
  transform(system: keyof typeof ResourceSystemTypes | string): string {
    return ResourceSystemTypes[system] ?? system;
  }
}
